var _toConsumableArray = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/toConsumableArray.js");

require("core-js/modules/esnext.global-this.js");

/**
 * query-sync-storage-persister
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).QuerySyncStoragePersister = {});
}(this, function (e) {
  "use strict";

  function t(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    var r,
        n = null;
    return function () {
      for (var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++) {
        i[_key] = arguments[_key];
      }

      r = i, null === n && (n = setTimeout(function () {
        e.apply(void 0, _toConsumableArray(r)), n = null;
      }, t));
    };
  }

  function r() {}

  e.createSyncStoragePersister = function (_ref) {
    var e = _ref.storage,
        _ref$key = _ref.key,
        n = _ref$key === void 0 ? "REACT_QUERY_OFFLINE_CACHE" : _ref$key,
        _ref$throttleTime = _ref.throttleTime,
        i = _ref$throttleTime === void 0 ? 1e3 : _ref$throttleTime,
        _ref$serialize = _ref.serialize,
        o = _ref$serialize === void 0 ? JSON.stringify : _ref$serialize,
        _ref$deserialize = _ref.deserialize,
        s = _ref$deserialize === void 0 ? JSON.parse : _ref$deserialize,
        l = _ref.retry;

    if (void 0 !== e) {
      var _r = function _r(t) {
        try {
          e.setItem(n, o(t));
        } catch (e) {
          return e;
        }
      };

      return {
        persistClient: t(function (e) {
          var t = e,
              n = _r(t),
              i = 0;

          for (; n && t;) {
            i++, t = null == l ? void 0 : l({
              persistedClient: t,
              error: n,
              errorCount: i
            }), t && (n = _r(t));
          }
        }, i),
        restoreClient: function restoreClient() {
          var t = e.getItem(n);
          if (t) return s(t);
        },
        removeClient: function removeClient() {
          e.removeItem(n);
        }
      };
    }

    return {
      persistClient: r,
      restoreClient: function restoreClient() {},
      removeClient: r
    };
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});